import React, { useState } from "react";
import "./_contact.scss";
import { BsBrowserChrome } from "react-icons/bs";
import DashboardSideBar from "./DashboardSideBar";
import { IoMail } from "react-icons/io5";
import { toast } from "react-toastify";
import emailjs from 'emailjs-com';


const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });
  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
    
  }
  
  const sendMail = (event) => {
    event.preventDefault(); // Prevent form submission
    
    // const { firstName,lastName, email,message } = formData;

    // const templateParams = {
    //   firstName:firstName,
    //   lastName:lastName,
    //   email: email,
    //   message: message,
    // };

    emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID,  process.env.REACT_APP_EMAILJS_TEMPLATE_ID, event.target, process.env.REACT_APP_EMAILJS_PUBLIC_KEY)
    // emailjs.sendForm("service_31l9mum", "template_dlw3fgk", event.target,"b7Yxfqta2A6xl9pZG")

      .then((response) => {
        toast.success("Email Sent Sucessfully!"); // Show success message
        // reset from data 
        setFormData({
            firstName: '',
            lastName: '',
            email: '',
            message: ''
          });
      })
      
      .catch((error) => {
        toast.error("Error sending email:", error); // Log error if any
      });
  }
  return (
    <DashboardSideBar>
      <div className="w-100">
        <div className="d-flex">
          <div className="contact w-100">
            <div className="top-contact">
              <div className="top-heading"><h1>Contact <span>Us</span></h1>
              <p>We’re here to help! Whether you have questions, feedback, or need assistance with the NexGen
              Inspector Assistant, we’d love to hear from you.</p></div>
              <div className="upper-contact">
                  <div className="link-section">
                    <div><BsBrowserChrome size={50} /></div>
                    <button> 
                      <a href="https:www.nexgeninspectorassistant.com" target="_blank" rel="noreferrer">www.nexgeninspectorassistant.com</a>
                     </button>
                  </div>
                  <div className="link-section">
                    <div><IoMail size={50} /></div>
                    <button>
                      <a href="mailto:support@nexgeninspectorassistant.com" target="_blank" rel="noreferrer">
                      support@nexgeninspectorassistant.com</a>
                    </button>
                  </div>
              </div>

            </div>
            <div className="main">
              <div className="contact-form">
                <div className="white"></div>
                <div className="blue"></div>
                <div className="main-form">
                  <div className="left">
                    <h2>
                    Let’s <span>Stay</span> Connected
                    </h2>
                    <p>
                    Bookmark our website and check back often for news, updates, and new features. Thank you for
                    choosing NexGen Inspector Assistant! 
                    </p>
                  </div>

                  <form className="right" onSubmit={sendMail}>
                    <div className="name-section">
                      <div className="input-wrapper">
                        <input type="text" placeholder="First Name" name="firstName" value={formData.firstName} onChange={handleChange} />
                      </div>
                      <div className="input-wrapper">
                        <input type="text" placeholder="Last Name" name="lastName" value={formData.lastName} onChange={handleChange}  />
                      </div>
                    </div>
                    <div className="input-wrapper">
                      <input type="email" placeholder="Email" name="email" value={formData.email} onChange={handleChange}  />
                    </div>
                    
                    <div className="input-wrapper">
                      <textarea placeholder="Your message..." rows={5} name="message" value={formData.message} onChange={handleChange}  />
                    </div>
                    <div className="add_databases_btn">
                      <button type="submit">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardSideBar>
  );
};

export default Contact;
